import PathConstants from './pathConstants';
import Main from '../layouts/BaseLayout/Main';
import AllRoutes from './AllRoutes';
import DashboardLayout from '../layouts/DashboardLayout';
import LayoutNavigator from './components/LayoutNavigator';
import Protected from './components/Protected';
import { Blocked, Page404 } from '../pages';
import AdminRoutes from './AdminRoutes';
import Linkway from '../features/Chats/components/Linkway';
import ComingSoon from '../pages/ComingSoon';
import VendorPage from '../features/teaAndSnacks/components/VendorPage';
import CanteenAdmin from '../features/teaAndSnacks/components/CanteenAdmin';
import Staff from '../features/teaAndSnacks/components/Staff';

const routes = {
  LAYOUTS: [
    {
      path: PathConstants.BASE,
      element: <LayoutNavigator />,
    },
    {
      path: PathConstants.USER,
      element: (
        <Protected>
          <Main />
        </Protected>
      ),
      children: AllRoutes,
    },
    {
      path: PathConstants.VENDOR,
      element: (
        <Protected layout='vendor'>
          <VendorPage />
        </Protected>
      ),
    },
    {
      path: PathConstants.CANTEEN,
      element: (
        <Protected layout='canteen'>
          <CanteenAdmin />
        </Protected>
      ),
    },
    {
      path: PathConstants.STAFF,
      element: (
        <Protected layout='staff'>
          <Staff />
        </Protected>
      ),
    },
    {
      path: PathConstants.ADMIN,
      element: (
        <Protected layout={'admin'}>
          <DashboardLayout />
        </Protected>
      ),
      children: AdminRoutes,
    },
    { path: PathConstants.CREDIT, element: <Linkway /> },
    { path: PathConstants.HOLD, element: <ComingSoon /> },
    { path: PathConstants.NOT_FOUND, element: <Page404 /> },
  ],
};

export default routes;
